export const parseHexString = (str: string): number[] => {
    const result = [];
    while (str.length >= 8) {
        result.push(parseInt(str.substring(0, 8), 16));
        str = str.substring(8, str.length);
    }
    return result;
};

export const createHexString = (arr: number[]): string => {
    let result = '';
    let z;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < arr.length; i++) {
        let str = arr[i].toString(16);
        z = 8 - str.length + 1;
        str = Array(z).join('0') + str;
        result += str;
    }

    return result;
};

//EXPORT
export const exportToCsv = (data: any, fileName: string, map: Map<string, string>): void => {
    const columns = getColumns(data);
    const csvData = convertToCsv(data, columns, map);
    downloadFile(csvData, fileName + '.csv', 'text/csv');
};

export const getColumns = (data: any[]): string[] => {
    const columns = [];
    data.forEach(row => {
        Object.keys(row).forEach(col => {
            if (!columns.includes(col)) {
                columns.push(col);
            }
        });
    });
    return columns;
};

export const convertToCsv = (data: any[], columns: string[], map: Map<string, string>): string => {
    let csv = '';
    const columnsTranslate = [];
    columns.forEach(col => {
        columnsTranslate.push(map.get(col));
    });
    csv += columnsTranslate.join(',') + '\n';
    data.forEach(row => {
        const values = [];
        columns.forEach(col => {
            values.push(row[col] || '');
        });
        csv += values.join(',') + '\n';
    });
    return csv;
};

export const downloadFile = (data: string, filename: string, type: string): void => {
    const blob = new Blob([data], { type: type });
    const link = document.createElement('a');
    link.setAttribute('href', URL.createObjectURL(blob));
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};